import { ResolvedRoute } from '@router/interfaces/resolved-route.ts';

export default [
    {
        path: '/packaging/edit/:id',
        name: 'packaging_edit',
        component: () => import('@src/packaging/packaging-edit.vue'),
        props(route: ResolvedRoute) {
            return {
                id: route.params!.id,
            };
        },
        meta: {
            title: 'Versandverpackung bearbeiten',
            role: 'ROLE_EDIT_PACKAGING',
        },
    },
    {
        path: '/packaging/list',
        name: 'packaging_list',
        component: () => import('@src/packaging/packaging-list.vue'),
        meta: {
            title: 'Versandverpackungen',
            role: 'ROLE_LIST_PACKAGING',
        },
    },
];
